import { useUser } from "../../contexts/UserContext/UserContext";
import BannerAlert from "./BannerAlert";
import CarPricingReadinessAlert from "./CarPricingReadinessAlert";
import CategoryPricingReadinessAlert from "./CategoryPricingReadinessAlert";
import SubExpAlert from "./SubExpAlert";
import TrialExpireAlert from "./TrialExpireAlert";

/**
 * Company-scoped banners must not mount on public routes (login, signup, etc.).
 */
const AuthenticatedBanners = () => {
    const { state } = useUser();

    if (!state?.isAuthenticated || !state?.user?.id) {
        return null;
    }

    return (
        <>
            <SubExpAlert />
            <BannerAlert />
            <TrialExpireAlert />
            <CategoryPricingReadinessAlert />
            <CarPricingReadinessAlert />
        </>
    );
};

export default AuthenticatedBanners;
